<template>
  <span class="d-flex justify-center">
    <v-btn :disabled="disabled" icon @click="handleSort">
      <v-icon v-if="orderAsc" :size="size">{{ iconUp }}</v-icon>
      <v-icon v-else :size="size">{{ iconDown }}</v-icon>
    </v-btn>
  </span>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import sortData from '@/mixins/sortData';

  export default {
    name: 'SortByButton',
    mixins: [sortData],
    props: {
      disabled: {
        default: false,
      },
      iconUp: {
        default: 'mdi-menu-up',
      },
      iconDown: {
        default: 'mdi-menu-down',
      },
      data: {
        required: true,
      },
      column: {
        required: true,
      },
      type: {
        type: String,
        default: 'string',
      },
      size: {
        default: '15',
      },
    },
    data: () => ({
      orderAsc: true,
    }),
    methods: {
      handleSort() {
        const sortedData = this.sortByCol({
          data: this.data,
          column: this.column,
          type: this.type,
          orderAsc: this.orderAsc,
        });
        this.orderAsc = !this.orderAsc;
        this.$emit('sortedData', sortedData);
      },
    },
  };
</script>
